import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGuest } from '../contexts/GuestContext';
import { useLanguage } from '../contexts/LanguageContext';

function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [sections, setSections] = useState([]);
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/legacy' || location.pathname === '/lt' || location.pathname === '/lt/legacy';
  const { guestGroup } = useGuest();
  const { lang, setLang, t, l } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isHomePage) {
      // Delay to ensure sections are rendered
      const timer = setTimeout(() => {
        const sectionElements = document.querySelectorAll('section[id]');
        const sectionData = Array.from(sectionElements).map(el => ({
          id: el.id,
          title: el.querySelector('h2, h3')?.textContent || el.id.charAt(0).toUpperCase() + el.id.slice(1),
        }));
        setSections(sectionData);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isHomePage, location, lang]); // Re-scan sections when language changes so titles update in nav

  const scrollToSection = (e, id) => {
    e.preventDefault();
    setIsOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleNavClick = (e, id) => {
    setIsOpen(false);
    if (!isHomePage) {
      return;
    } else {
      scrollToSection(e, id);
    }
  };

  return (
    <>
      <button className={`hamburger ${isScrolled ? 'visible' : ''}`} onClick={() => setIsOpen(!isOpen)} aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav className={`nav ${isScrolled ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}>
        {isHomePage ? (
          <>
            {sections.map(section => (
              <a key={section.id} href={`#${section.id}`} onClick={e => handleNavClick(e, section.id)}>
                {section.title}
              </a>
            ))}
            <Link to={l('/gallery')} onClick={() => setIsOpen(false)}>
              {t('gallery')}
            </Link>
            {!guestGroup && (
              <Link to={l('/guest/login')} onClick={() => setIsOpen(false)}>
                {t('guestLogin')}
              </Link>
            )}
          </>
        ) : (
          <>
            <Link to={l('/')} onClick={() => setIsOpen(false)}>
              {t('home')}
            </Link>
            <Link to={l('/gallery')} onClick={() => setIsOpen(false)}>
              {t('gallery')}
            </Link>
            {!guestGroup && (
              <Link to={l('/guest/login')} onClick={() => setIsOpen(false)}>
                {t('guestLogin')}
              </Link>
            )}
          </>
        )}
      </nav>
      <div className="lang-switcher-floating">
        <button 
          className={`lang-btn ${lang === 'en' ? 'active' : ''}`} 
          onClick={() => setLang('en')}
        >
          EN
        </button>
        <button 
          className={`lang-btn ${lang === 'lt' ? 'active' : ''}`} 
          onClick={() => setLang('lt')}
        >
          LT
        </button>
      </div>
    </>
  );
}

export default Navigation;
